function initArticle(){
if(window.__lwaInit)return;window.__lwaInit=true;  /* template loads this script twice — run once */
if(!window.JOURNAL||!window.JOURNAL.posts){window.__lwaInit=false;setTimeout(initArticle,50);return}
const J=window.JOURNAL,posts=J.posts,slug=new URLSearchParams(window.location.search).get("j");
if(!slug){document.getElementById("title").textContent="Article not found";return}
const post=posts.find(p=>p.slug===slug);
if(!post){document.getElementById("title").textContent="Article not found";return}

/* ===== INJECTED STYLES (self-contained; dark-mode aware via theme vars) ===== */
const st=document.createElement("style");
st.textContent=`
/* ===== floating player: slim bottom DOCK — page chrome, not a floating box ===== */
.lwa-player{position:fixed;left:0;right:0;bottom:0;z-index:60;transform:translateY(130%);opacity:0;visibility:hidden;pointer-events:none;transition:transform .45s cubic-bezier(.2,.8,.2,1),opacity .3s;background:color-mix(in srgb,var(--paper,#f5f1e8) 88%,transparent);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border-top:1px solid var(--hairline,rgba(28,26,23,.14));color:var(--ink,#1c1a17);padding:9px 18px calc(9px + env(safe-area-inset-bottom,0px));box-shadow:0 -8px 28px rgba(20,18,16,.07)}
.lwa-player.show{transform:none;opacity:1;visibility:visible;pointer-events:auto}
.lwa-player .row{max-width:720px;margin:0 auto;display:flex;align-items:center;gap:9px}
.lwa-player .pt{font:11px/1.2 var(--sans,ui-sans-serif,sans-serif);letter-spacing:.04em;opacity:.55;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:180px}
.lwa-player button{background:none;border:none;color:inherit;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:6px;border-radius:50%;transition:background .2s,opacity .2s;opacity:.8}
.lwa-player button:hover{background:color-mix(in srgb,var(--ink,#1c1a17) 8%,transparent);opacity:1}
.lwa-player .pp{width:34px;height:34px;border-radius:50%;background:var(--ink,#1c1a17);color:var(--paper,#f5f1e8);opacity:1}
.lwa-player .pp:hover{filter:brightness(1.2)}
.lwa-player svg{width:17px;height:17px;fill:currentColor}
.lwa-player .pp svg{width:15px;height:15px}
.lwa-track{flex:1;min-width:80px;height:24px;display:flex;align-items:center;cursor:pointer;position:relative}
.lwa-track .rail{position:absolute;left:0;right:0;height:2px;border-radius:2px;background:color-mix(in srgb,var(--ink,#1c1a17) 14%,transparent)}
.lwa-track .fill{position:absolute;left:0;height:2px;border-radius:2px;background:var(--ink,#1c1a17);width:0%}
.lwa-track .dot{position:absolute;width:9px;height:9px;border-radius:50%;background:var(--ink,#1c1a17);left:0%;transform:translateX(-50%);box-shadow:0 0 0 3px color-mix(in srgb,var(--paper,#f5f1e8) 70%,transparent)}
.lwa-time{font:11px/1 ui-monospace,monospace;opacity:.6;white-space:nowrap;min-width:76px;text-align:center}
.lwa-speed{font:11px/1 ui-monospace,monospace;border:1px solid var(--hairline,rgba(28,26,23,.3))!important;border-radius:999px!important;padding:5px 9px!important;min-width:40px}
body.lwa-dockpad{padding-bottom:76px}
/* minimized: 44px dot bottom-right, progress ring only */
.lwa-player.mini{left:auto;right:18px;bottom:calc(18px + env(safe-area-inset-bottom,0px));padding:5px;border-radius:50%;border-top:none;box-shadow:0 8px 24px rgba(20,18,16,.25);background:rgba(20,18,16,.92);color:#f5f1e8;cursor:pointer}
.lwa-player.mini .pt,.lwa-player.mini .rw,.lwa-player.mini .fw,.lwa-player.mini .lwa-track,.lwa-player.mini .lwa-time,.lwa-player.mini .lwa-speed,.lwa-player.mini .minbtn,.lwa-player.mini .close{display:none}
.lwa-player.mini .pp{background:#f5f1e8;color:#141210}
.lwa-player .ring{display:none;position:absolute;inset:0;width:100%;height:100%;pointer-events:none}
.lwa-player.mini .ring{display:block}
.lwa-player button:focus-visible,#listenBtn:focus-visible{outline:2px solid var(--gold,#B08D57);outline-offset:2px}
@media(max-width:760px){.lwa-player .pt{display:none}}
@media(max-width:560px){.lwa-time{display:none}}
@media(prefers-reduced-motion:reduce){.lwa-player{transition:none}}
/* ===== header listen band (FT-style audio module, full controls inline) ===== */
.lwa-listenband{position:relative;display:flex;align-items:center;gap:16px;margin-top:1.2rem;padding:1.1rem 1.2rem 1.35rem;border-radius:12px;background:color-mix(in srgb,var(--ink,#1c1a17) 4.5%,transparent);border:1px solid var(--hairline,rgba(28,26,23,.12))}
#minutes{display:none}
#listenBtn.listen-disc{width:54px;height:54px;min-width:54px;border-radius:50%;border:none;background:var(--ink,#1c1a17);color:var(--paper,#f5f1e8);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s cubic-bezier(.2,.8,.2,1),box-shadow .25s;padding:0;box-shadow:0 2px 10px rgba(28,26,23,.18)}
#listenBtn.listen-disc:hover{transform:scale(1.07);box-shadow:0 4px 16px rgba(28,26,23,.28)}
#listenBtn.listen-disc svg{width:20px;height:20px;fill:currentColor}
.lwa-listenband .lt{display:flex;flex-direction:column;gap:4px;min-width:0;flex:1}
.lwa-listenband .le{font:700 .72rem/1 var(--sans,ui-sans-serif,sans-serif);letter-spacing:.24em;text-transform:uppercase;display:flex;align-items:center;gap:9px}
.lwa-listenband .lm{font:12.5px/1.35 var(--sans,ui-sans-serif,sans-serif);opacity:.62}
.lwa-listenband .bc{display:flex;gap:2px;margin-left:auto;align-items:center}
.lwa-listenband .bc button{background:none;border:none;color:inherit;cursor:pointer;padding:7px;border-radius:50%;opacity:.55;display:flex;align-items:center;transition:opacity .2s,background .2s}
.lwa-listenband .bc button:hover{opacity:1;background:color-mix(in srgb,var(--ink,#1c1a17) 7%,transparent)}
.lwa-listenband .bc svg{width:18px;height:18px;fill:currentColor}
.lwa-listenband .bc .spd{font:11px/1 ui-monospace,monospace;border:1px solid var(--hairline,rgba(28,26,23,.28));border-radius:999px;padding:6px 9px;opacity:.75}
.lwa-listenband .btrack{position:absolute;left:1.2rem;right:1.2rem;bottom:0;height:12px;cursor:pointer}
.lwa-listenband .btrack .brail{position:absolute;left:0;right:0;bottom:0;height:2px;background:color-mix(in srgb,var(--ink,#1c1a17) 12%,transparent)}
.lwa-listenband .btrack .bfill{position:absolute;left:0;bottom:0;height:2px;background:var(--gold,#B08D57);width:0%;transition:width .3s linear}
.lwa-listenband .eq{display:none;gap:2.5px;align-items:flex-end;height:10px}
.lwa-listenband.playing .eq{display:inline-flex}
.lwa-listenband .eq i{width:2.5px;height:4px;background:var(--gold,#B08D57);border-radius:1px;animation:lwaEq .9s ease-in-out infinite}
.lwa-listenband .eq i:nth-child(2){animation-delay:.15s}
.lwa-listenband .eq i:nth-child(3){animation-delay:.3s}
@keyframes lwaEq{0%,100%{height:4px}50%{height:10px}}
@media(prefers-reduced-motion:reduce){.lwa-listenband .eq i{animation:none}#listenBtn.listen-disc:hover{transform:none}}
.lwa-share{position:fixed;left:18px;top:50%;transform:translateY(-50%);display:flex;flex-direction:column;gap:8px;z-index:50;opacity:0;visibility:hidden;transition:opacity .4s}
.lwa-share.show{opacity:1;visibility:visible}
.lwa-share a,.lwa-share button{width:38px;height:38px;border-radius:50%;border:1px solid var(--hairline,rgba(28,26,23,.18));background:var(--paper,#f5f1e8);color:var(--ink,#1c1a17);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .2s;text-decoration:none}
.lwa-share a:hover,.lwa-share button:hover{border-color:var(--gold,#B08D57);color:var(--gold,#B08D57);transform:translateY(-2px)}
.lwa-share svg{width:15px;height:15px;fill:currentColor}
.lwa-share-inline{display:none}
.lwa-feat{margin:2.5rem 0 1rem;border:1px solid var(--hairline,rgba(28,26,23,.15));border-radius:14px;overflow:hidden;background:var(--card,#fff)}
.lwa-feat .fw{display:grid;grid-template-columns:1fr 1.15fr}
.lwa-feat .fi{position:relative;min-height:260px}
.lwa-feat .fi img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}
.lwa-feat .fc{padding:1.6rem 1.7rem;display:flex;flex-direction:column;gap:.55rem}
.lwa-feat .kick{font:10px/1 ui-sans-serif,sans-serif;letter-spacing:.3em;text-transform:uppercase;color:var(--gold,#B08D57)}
.lwa-feat h3{margin:0;font-size:1.3rem;line-height:1.25}
.lwa-feat .pr{font:600 .95rem/1 ui-sans-serif,sans-serif}
.lwa-feat .stars{color:var(--gold,#B08D57);font-size:.85rem;letter-spacing:.08em}
.lwa-feat .agg{font:12px/1.4 ui-sans-serif,sans-serif;opacity:.65;margin-left:.5em;letter-spacing:0}
.lwa-feat blockquote{margin:.35rem 0 0;padding-left:.9rem;border-left:2px solid var(--gold,#B08D57);font-style:italic;font-size:.92rem;line-height:1.5;opacity:.9}
.lwa-feat blockquote span{display:block;font-style:normal;font-size:.72rem;opacity:.6;margin-top:.3rem;letter-spacing:.05em}
.lwa-feat .cta-row{display:flex;gap:.6rem;margin-top:.7rem;flex-wrap:wrap}
.lwa-feat .btn{display:inline-block;padding:.72rem 1.4rem;border-radius:10px;font:600 .82rem/1 ui-sans-serif,sans-serif;letter-spacing:.06em;text-transform:uppercase;text-decoration:none;transition:all .2s}
.lwa-feat .btn.p{background:var(--ink,#1c1a17);color:var(--paper,#f5f1e8)}
.lwa-feat .btn.p:hover{background:var(--gold,#B08D57);color:#141210}
.lwa-feat .btn.g{border:1px solid var(--hairline,rgba(28,26,23,.25));color:inherit}
.lwa-feat .btn.g:hover{border-color:var(--gold,#B08D57);color:var(--gold,#B08D57)}
.lwa-toast{position:fixed;left:50%;bottom:96px;transform:translate(-50%,10px);background:var(--ink,#1c1a17);color:var(--paper,#f5f1e8);padding:.55rem 1.1rem;border-radius:999px;font:12px/1 ui-sans-serif,sans-serif;letter-spacing:.05em;opacity:0;visibility:hidden;transition:all .3s;z-index:70;border:1px solid rgba(176,141,87,.45)}
.lwa-toast.show{opacity:1;visibility:visible;transform:translate(-50%,0)}
@media(max-width:1100px){.lwa-share{display:none}.lwa-share-inline{display:flex;gap:8px;margin-top:.9rem}.lwa-share-inline a,.lwa-share-inline button{width:36px;height:36px;border-radius:50%;border:1px solid var(--hairline,rgba(28,26,23,.18));background:transparent;color:inherit;display:flex;align-items:center;justify-content:center;cursor:pointer;text-decoration:none}.lwa-share-inline svg{width:14px;height:14px;fill:currentColor}}
@media(max-width:640px){.lwa-feat .fw{grid-template-columns:1fr}.lwa-feat .fi{min-height:210px}.lwa-time{display:none}.lwa-track{min-width:70px}}
@media(prefers-reduced-motion:reduce){.lwa-player,.lwa-share,.lwa-toast{transition:none}}
`;
document.head.appendChild(st);

document.getElementById("seriesName").textContent=J.series[post.series]?.name||post.series;
document.getElementById("title").textContent=post.title;
document.getElementById("dek").textContent=post.dek;
document.getElementById("minutes").textContent=`${post.minutes} min read`;
document.getElementById("heroImg").src=post.hero.replace("&width=1400","&width=960");
document.getElementById("heroImg").alt=post.title;

const body=document.getElementById("body");
body.innerHTML=post.blocks.map(b=>b.p?`<p>${b.p}</p>`:b.h?`<h2>${b.h}</h2>`:b.q?`<div class="pull">${b.q}</div>`:"").join("");

/* Editorial figures: one per H2 section, inserted under its heading.
   figs = [[headingText, url, productUrl?], ...]. */
if(post.figs&&post.figs.length){
  const h2s=[...body.querySelectorAll("h2")];
  post.figs.forEach(pair=>{
    const h=pair[0],url=pair[1],link=pair[2]||"";
    const target=h2s.find(x=>x.textContent.trim()===h.trim());
    const fig=document.createElement("figure");
    fig.className="fig";
    const img=`<img src="${url}" alt="${(h||post.title)} — illustration" loading="lazy">`;
    const cap=link?`<figcaption><a href="${link}" style="color:inherit;border-bottom:1px solid currentColor">Shop the piece&nbsp;↗</a></figcaption>`:"";
    fig.innerHTML=(link?`<a href="${link}" title="Shop the featured piece">${img}</a>`:img)+cap;
    if(target){target.after(fig)}
    else{const paras=body.querySelectorAll("p");(paras[1]||paras[paras.length-1])?.after(fig)}
  });
}else if(post.fig){
  const paras=body.querySelectorAll("p");
  const anchor=paras[1]||paras[paras.length-1];
  if(anchor){
    const fig=document.createElement("figure");
    fig.className="fig";
    fig.innerHTML=`<img src="${post.fig}" alt="${post.title} — illustration" loading="lazy">`;
    anchor.after(fig);
  }
}

/* ===== TOAST ===== */
const toastEl=document.createElement("div");toastEl.className="lwa-toast";document.body.appendChild(toastEl);
let toastT=null;
function toast(msg){toastEl.textContent=msg;toastEl.classList.add("show");clearTimeout(toastT);toastT=setTimeout(()=>toastEl.classList.remove("show"),2200)}

/* ===== AUDIO: full floating player (play/pause · ±15s · scrub · speed) ===== */
const audio=document.getElementById("audioPlayer"),
      btn=document.getElementById("listenBtn"),
      oldPill=document.getElementById("listenFloat");
audio.src=`https://res.cloudinary.com/dopnordk7/video/upload/journal_audio/${slug}.m4a`;
audio.preload="metadata";
if(oldPill)oldPill.style.display="none";  /* superseded by the full player bar */

const SVG={
  play:'<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>',
  pause:'<svg viewBox="0 0 24 24"><path d="M6 5h4v14H6zm8 0h4v14h-4z"/></svg>',
  back:'<svg viewBox="0 0 24 24"><path d="M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8z"/><text x="12" y="16" font-size="7" text-anchor="middle" fill="currentColor" style="font:7px sans-serif">15</text></svg>',
  fwd:'<svg viewBox="0 0 24 24"><path d="M12 5V1l5 5-5 5V7c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6h2c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8z"/><text x="12" y="16" font-size="7" text-anchor="middle" fill="currentColor" style="font:7px sans-serif">15</text></svg>',
  x:'<svg viewBox="0 0 24 24"><path d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/></svg>'
};
/* header listen band: disc button + eyebrow + live progress meta */
const band=document.createElement("div");band.className="lwa-listenband";
const btnHome=btn.parentElement,minutesEl=document.getElementById("minutes");
btn.className="listen-disc";btn.id="listenBtn";btn.setAttribute("aria-pressed","false");btn.setAttribute("aria-label","Play audio narration");btn.innerHTML=SVG.play;
band.appendChild(btn);
const lt=document.createElement("div");lt.className="lt";
lt.innerHTML=`<span class="le">Listen to the story <span class="eq" aria-hidden="true"><i></i><i></i><i></i></span></span><span class="lm">${post.minutes} min read · ~${post.minutes} min narration · pause &amp; rewind anytime</span>`;
band.appendChild(lt);
const bc=document.createElement("div");bc.className="bc";
bc.innerHTML=`<button class="rw" aria-label="Back 15 seconds">${SVG.back}</button><button class="fw" aria-label="Forward 15 seconds">${SVG.fwd}</button><button class="spd" aria-label="Playback speed">1×</button>`;
band.appendChild(bc);
const bt=document.createElement("div");bt.className="btrack";bt.setAttribute("role","slider");bt.setAttribute("aria-label","Seek narration");
bt.innerHTML=`<div class="brail"></div><div class="bfill"></div>`;
band.appendChild(bt);
if(btnHome&&minutesEl&&btnHome.contains(minutesEl)){btnHome.after(band)}else{band && (btnHome?btnHome.after(band):null)}
const metaEl=lt.querySelector(".lm");

const bar=document.createElement("div");
bar.className="lwa-player";bar.setAttribute("role","region");bar.setAttribute("aria-label","Audio player");
bar.innerHTML=`
  <svg class="ring" viewBox="0 0 48 48"><circle cx="24" cy="24" r="21" stroke="rgba(255,255,255,.22)" stroke-width="2.5" fill="none"/><circle class="ringfill" cx="24" cy="24" r="21" stroke="#f5f1e8" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-dasharray="132" stroke-dashoffset="132" transform="rotate(-90 24 24)"/></svg>
  <div class="row">
    <span class="pt">${post.title}</span>
    <button class="pp" aria-label="Play or pause">${SVG.play}</button>
    <button class="rw" aria-label="Back 15 seconds">${SVG.back}</button>
    <button class="fw" aria-label="Forward 15 seconds">${SVG.fwd}</button>
    <div class="lwa-track"><div class="rail"></div><div class="fill"></div><div class="dot"></div></div>
    <span class="lwa-time">0:00 / 0:00</span>
    <button class="lwa-speed" aria-label="Playback speed">1×</button>
    <button class="minbtn" aria-label="Minimize player"><svg viewBox="0 0 24 24"><path d="M7.4 8.6 12 13.2l4.6-4.6L18 10l-6 6-6-6z"/></svg></button>
    <button class="close" aria-label="Close player">${SVG.x}</button>
  </div>`;
document.body.appendChild(bar);

const ppBtn=bar.querySelector(".pp"),bfill=bt.querySelector(".bfill"),
      dfill=bar.querySelector(".fill"),dDot=bar.querySelector(".dot"),dTime=bar.querySelector(".lwa-time"),
      dTrack=bar.querySelector(".lwa-track"),
      speedBtn=bc.querySelector(".spd"),dSpeed=bar.querySelector(".lwa-speed"),
      SPEEDS=[1,1.25,1.5,2];let speedIx=0,barDismissed=false;
function syncPad(){document.body.classList.toggle("lwa-dockpad",bar.classList.contains("show")&&!bar.classList.contains("mini"))}

function fmt(s){if(!isFinite(s))return"0:00";s=Math.floor(s);return`${Math.floor(s/60)}:${String(s%60).padStart(2,"0")}`}
function setPlaying(on){
  btn.setAttribute("aria-pressed",on?"true":"false");
  btn.setAttribute("aria-label",on?"Pause audio narration":"Play audio narration");
  btn.innerHTML=on?SVG.pause:SVG.play;
  band.classList.toggle("playing",on);
  ppBtn.innerHTML=on?SVG.pause:SVG.play;
  if(on){barDismissed=false;bar.classList.add("show");syncPad()}
}
function toggleAudio(){if(audio.paused){audio.play();setPlaying(true)}else{audio.pause();setPlaying(false)}}
btn.onclick=toggleAudio;
ppBtn.onclick=toggleAudio;
const rwFn=()=>{audio.currentTime=Math.max(0,audio.currentTime-15)},fwFn=()=>{audio.currentTime=Math.min(audio.duration||0,audio.currentTime+15)};
bc.querySelector(".rw").onclick=rwFn;bar.querySelector(".rw").onclick=rwFn;
bc.querySelector(".fw").onclick=fwFn;bar.querySelector(".fw").onclick=fwFn;
const spFn=()=>{speedIx=(speedIx+1)%SPEEDS.length;audio.playbackRate=SPEEDS[speedIx];speedBtn.textContent=SPEEDS[speedIx]+"×";dSpeed.textContent=SPEEDS[speedIx]+"×"};
speedBtn.onclick=spFn;dSpeed.onclick=spFn;
bar.querySelector(".minbtn").onclick=()=>{bar.classList.add("mini");syncPad()};
bar.querySelector(".close").onclick=()=>{audio.pause();setPlaying(false);barDismissed=true;bar.classList.remove("show");syncPad()};
bar.addEventListener("click",e=>{
  /* mini dot: tap anywhere except play to restore the dock */
  if(bar.classList.contains("mini")&&!e.target.closest(".pp,.minbtn,.close")){bar.classList.remove("mini");syncPad();e.stopPropagation()}
});
audio.onended=()=>setPlaying(false);
const ringFill=bar.querySelector(".ringfill");
audio.ontimeupdate=()=>{
  const d=audio.duration||0,p=d?audio.currentTime/d*100:0;
  bfill.style.width=p+"%";dfill.style.width=p+"%";dDot.style.left=p+"%";
  ringFill.style.strokeDashoffset=132*(1-p/100);
  dTime.textContent=`${fmt(audio.currentTime)} / ${fmt(d)}`;
  metaEl.textContent=d?`${fmt(audio.currentTime)} of ${fmt(d)} · narration`:`${post.minutes} min read · ~${post.minutes} min narration`;
};
const seekFn=(el)=>e=>{const r=el.getBoundingClientRect(),ratio=Math.min(Math.max((e.clientX-r.left)/r.width,0),1);if(isFinite(audio.duration))audio.currentTime=ratio*audio.duration};
bt.onclick=seekFn(bt);dTrack.onclick=seekFn(dTrack);
/* Show the dock when the header Listen band scrolls away (unless dismissed) */
if("IntersectionObserver" in window){
  new IntersectionObserver(entries=>{
    if(!barDismissed||!audio.paused)bar.classList.toggle("show",!entries[0].isIntersecting);
    syncPad();
  },{rootMargin:"-80px 0px 0px 0px"}).observe(band);
}else{bar.classList.add("show");syncPad()}

/* ===== SHARE: side rail (desktop) + inline row (mobile) ===== */
const pageUrl=encodeURIComponent(location.href),
      shareText=encodeURIComponent(post.title+" — Live Wall Arts Journal"),
      pinMedia=encodeURIComponent(post.hero);
const SHARES=[
  {n:"X",svg:'<svg viewBox="0 0 24 24"><path d="M18.9 2H22l-6.8 7.8L23.2 22h-6.3l-4.9-6.4L6.4 22H3.3l7.3-8.3L2.8 2h6.4l4.4 5.9L18.9 2zm-1.1 18.1h1.7L7.1 3.8H5.3l12.5 16.3z"/></svg>',u:`https://twitter.com/intent/tweet?text=${shareText}&url=${pageUrl}`},
  {n:"Facebook",svg:'<svg viewBox="0 0 24 24"><path d="M13.5 22v-8.2h2.8l.4-3.2h-3.2V8.6c0-.9.3-1.6 1.6-1.6h1.7V4.1c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.3H7.3v3.2h2.8V22h3.4z"/></svg>',u:`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`},
  {n:"Pinterest",svg:'<svg viewBox="0 0 24 24"><path d="M12 2C6.5 2 2 6.5 2 12c0 4.2 2.6 7.8 6.4 9.3-.1-.8-.2-2 0-2.9l1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.4 1.8-2.4.9 0 1.3.6 1.3 1.4 0 .9-.6 2.2-.9 3.4-.2 1 .5 1.8 1.5 1.8 1.8 0 3.2-1.9 3.2-4.7 0-2.4-1.7-4.1-4.2-4.1-2.8 0-4.5 2.1-4.5 4.3 0 .9.3 1.8.8 2.3.1.1.1.2.1.3l-.3 1.1c0 .2-.1.2-.3.1-1.2-.6-2-2.4-2-3.9 0-3.2 2.3-6.1 6.7-6.1 3.5 0 6.2 2.5 6.2 5.8 0 3.5-2.2 6.3-5.2 6.3-1 0-2-.5-2.3-1.1l-.6 2.4c-.2.9-.8 2-1.2 2.6.9.3 1.9.4 2.9.4 5.5 0 10-4.5 10-10S17.5 2 12 2z"/></svg>',u:`https://pinterest.com/pin/create/button/?url=${pageUrl}&media=${pinMedia}&description=${shareText}`},
];
function shareButtons(cls){
  const w=document.createElement("div");w.className=cls;
  SHARES.forEach(s=>{const a=document.createElement("a");a.href=s.u;a.target="_blank";a.rel="noopener";a.title=`Share on ${s.n}`;a.setAttribute("aria-label",`Share on ${s.n}`);a.innerHTML=s.svg;w.appendChild(a)});
  const cp=document.createElement("button");cp.type="button";cp.title="Copy link";cp.setAttribute("aria-label","Copy link");
  cp.innerHTML='<svg viewBox="0 0 24 24"><path d="M10.6 13.4a1 1 0 0 0 1.4 1.4l4-4a3 3 0 0 0-4.2-4.2l-2.3 2.3a1 1 0 1 0 1.4 1.4l2.3-2.3a1 1 0 0 1 1.4 1.4l-4 4z"/><path d="M13.4 10.6a1 1 0 0 0-1.4-1.4l-4 4a3 3 0 0 0 4.2 4.2l2.3-2.3a1 1 0 1 0-1.4-1.4l-2.3 2.3a1 1 0 0 1-1.4-1.4l4-4z"/></svg>';
  cp.onclick=()=>{(navigator.clipboard?navigator.clipboard.writeText(location.href):Promise.reject()).then(()=>toast("Link copied")).catch(()=>{const t=document.createElement("textarea");t.value=location.href;document.body.appendChild(t);t.select();document.execCommand("copy");t.remove();toast("Link copied")})};
  w.appendChild(cp);
  if(navigator.share){
    const ns=document.createElement("button");ns.type="button";ns.title="Share…";ns.setAttribute("aria-label","Share");
    ns.innerHTML='<svg viewBox="0 0 24 24"><path d="M12 3l4.5 4.5-1.4 1.4L13 6.8V15h-2V6.8L8.9 8.9 7.5 7.5 12 3zM5 19h14v2H5z" transform="translate(0 -1)"/></svg>';
    ns.onclick=()=>navigator.share({title:post.title,text:post.dek,url:location.href}).catch(()=>{});
    w.appendChild(ns);
  }
  return w;
}
const rail=shareButtons("lwa-share");document.body.appendChild(rail);
window.addEventListener("scroll",()=>rail.classList.toggle("show",(window.scrollY||0)>420),{passive:true});
const headerMeta=document.getElementById("listenBtn")?.parentElement;
if(headerMeta)headerMeta.after(shareButtons("lwa-share-inline"));

/* ===== FEATURED PIECE + REVIEWS CTA (after the story, before rails) ===== */
const featHandle=(()=>{
  const l=post.figs&&post.figs.find(f=>f[2]);
  if(l)return l[2].split("/products/")[1];
  if(post.handles&&post.handles.length)return post.handles[0];
  return null;
})();
const FALLBACK_REVIEWS=[
  {a:"Charlene",t:"Really love this print. Would highly recommend this seller and print."},
  {a:"Natalie",t:"Beautiful piece, glad I get to show it in my office!"}
];
function stars(){"★★★★★";return "★★★★★"}
function renderFeat(p,quotes,aggLine){
  const feat=document.createElement("div");feat.className="lwa-feat";
  const img=p.featured_image?p.featured_image.replace(/\.(\w+)$/,"_600x.$1"):"";
  const prices=(p.variants||[]).map(v=>v.price/100);
  const pr=prices.length?(Math.min(...prices)===Math.max(...prices)?`$${Math.min(...prices).toFixed(0)}`:`$${Math.min(...prices).toFixed(0)} – $${Math.max(...prices).toFixed(0)}`):"";
  feat.innerHTML=`<div class="fw">
    <div class="fi">${img?`<img src="${img}" alt="${p.title}" loading="lazy">`:""}</div>
    <div class="fc">
      <span class="kick">The piece in this story</span>
      <h3>${p.title}</h3>
      <div><span class="pr">${pr}</span></div>
      <div><span class="stars">★★★★★</span><span class="agg">${aggLine||"4.7 · 227 verified buyer reviews"}</span></div>
      ${quotes.map(q=>`<blockquote>“${q.t}”<span>— ${q.a} · verified Etsy review</span></blockquote>`).join("")}
      <div class="cta-row">
        <a class="btn p" href="/products/${featHandle}">View the piece →</a>
        <a class="btn g" href="/pages/view?h=${featHandle}">See it in your room</a>
      </div>
    </div></div>`;
  body.after(feat);  /* featured piece card sits immediately after the story */
}
if(featHandle){
  Promise.all([
    fetch(`/products/${featHandle}.js`).then(r=>r.ok?r.json():null).catch(()=>null),
    fetch("https://etsy.reputon.com/app/storefront/widget?shop=41448c-26.myshopify.com").then(r=>r.ok?r.json():null).catch(()=>null)
  ]).then(([p,rep])=>{
    if(!p)return;
    let quotes=FALLBACK_REVIEWS;
    let aggLine="4.7 · 227 verified buyer reviews"; /* fallback matches home/PDP */
    try{
      const rd=(rep&&(rep.reviewsData||rep))||{};
      const revs=rd.reviews||[];
      const rating=rd.rating||rd.averageRating, total=rd.total||rd.count||(revs.length?null:null);
      if(rating&&total)aggLine=`${Number(rating).toFixed(1)} · ${total} verified buyer reviews`;
      else if(total)aggLine=`4.7 · ${total} verified buyer reviews`;
      const BAD=/no frame|price|shipping|late|disappoint|refund|broken|damage|missing/i;
      const good=revs.filter(r=>r.rating===5&&r.text&&r.text.length>50&&!/^Etsy [A-Z]$/.test(r.authorName||"")&&!BAD.test(r.text));
      if(good.length>=2)quotes=good.slice(0,2).map(r=>({a:r.authorName,t:r.text.length>140?r.text.slice(0,137).trim()+"…":r.text}));
    }catch(e){}
    renderFeat(p,quotes,aggLine);
  });
}

/* ===== SHOP RAIL: pieces named in the story ===== */
if(post.handles&&post.handles.length>0){
  const rail2=document.getElementById("railSection"),grid=document.getElementById("railGrid");
  rail2.style.display="block";
  const handles=post.handles.slice(0,6);
  Promise.all(handles.map(h=>fetch(`/products/${h}.js`).then(r=>r.ok?r.json():null).catch(()=>null))).then(prods=>{
    grid.innerHTML=handles.map((h,i)=>{
      const p=prods[i];
      const title=p?p.title:h.split("-").map(w=>w.charAt(0).toUpperCase()+w.slice(1)).join(" ");
      const img=p&&p.featured_image?`<div class="ph"><img src="${p.featured_image.replace(/\.(\w+)$/,"_400x.$1")}" alt="${title}" loading="lazy"></div>`:"";
      const price=p?`From $${(p.price/100).toFixed(0)}`:"";
      return `<a class="rcard" href="/products/${h}">${img}<div class="rb"><h4>${title}</h4><div class="pr">${price}</div></div></a>`;
    }).join("");
  });
}

/* ===== BEST SELLERS CTA ===== */
const ctaGrid=document.getElementById("ctaGrid");
fetch("/collections/all/products.json?sort_by=best-selling&limit=6").then(r=>r.json()).then(d=>{
  const prods=(d.products||[]).slice(0,6);
  if(!prods.length)return;
  ctaGrid.innerHTML=prods.map(p=>{
    const img=p.images&&p.images.length?p.images[0].src.replace(/\.(\w+)(\?|$)/,"_400x.$1$2"):"";
    const price=p.variants&&p.variants.length?`From $${parseFloat(p.variants[0].price).toFixed(0)}`:"";
    return `<a class="rcard" href="/products/${p.handle}">${img?`<div class="ph"><img src="${img}" alt="${p.title}" loading="lazy"></div>`:""}<div class="rb"><h4>${p.title}</h4><div class="pr">${price}</div></div></a>`;
  }).join("");
}).catch(()=>{});

/* ===== NEXT ARTICLE ===== */
const idx=posts.findIndex(p=>p.slug===slug),next=posts[idx+1]||posts[0],nextLink=document.getElementById("nextLink");
nextLink.href=`/pages/journal-article?j=${next.slug}`;
document.getElementById("nextTitle").textContent=next.title;

/* ===== SCROLL: compact header + progress ===== */
const header=document.getElementById("articleHeader"),progressBar=document.getElementById("progressBar"),articleContent=document.getElementById("articleContent");
function onScroll(){
  const scrollTop=window.scrollY||window.pageYOffset,
        docHeight=articleContent.scrollHeight-window.innerHeight,
        scrollPercent=Math.min(scrollTop/Math.max(docHeight,1),1);
  scrollTop>100?header.classList.add("compact"):header.classList.remove("compact");
  progressBar.style.width=scrollPercent*100+"%";
}
window.addEventListener("scroll",onScroll,{passive:!0});

/* ===== DARK MODE ===== */
const darkToggle=document.getElementById("darkToggle"),root=document.documentElement;
localStorage.getItem("theme")==="dark"&&root.setAttribute("data-theme","dark");
darkToggle.onclick=()=>{
  root.getAttribute("data-theme")==="dark"?(root.removeAttribute("data-theme"),localStorage.setItem("theme","light")):(root.setAttribute("data-theme","dark"),localStorage.setItem("theme","dark"));
};
onScroll();
}
initArticle();
